import { ru } from "date-fns/locale";
import { format } from "date-fns";

export const getWithZero = (num: number): string =>
  num < 10 ? "0" + num : String(num);

export const formatTime = (date: Date) => {
  // const hours = date.getHours();
  // const minutes = date.getMinutes();
  const mskTime = date.toLocaleString("en-US", {
    timeZone: "Europe/Moscow",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  });
  return `${mskTime}`;
};

export const formatDate = (date: Date, pattern = "dd.MM.yyyy") =>
  format(date, pattern, { locale: ru });
